export const HOME = "/",
  PLAYERS = "/players",
  STORY = "/story",
  MONSTERS = "/monsters",
  NOTES = "/notes";
